import 'style-loader!./form-group.css';
import idGenerator from 'cadenza/utils/id-generator';

const controlIdGen = idGenerator('form-control');

class FormGroup extends HTMLElement {

  constructor () {
    super();
    this.observer = new MutationObserver(this.updateDisabled.bind(this));
  }

  connectedCallback () {
    const label = this.label = this.querySelector('label');
    const control = this.control = this.querySelector('input,select,textarea,.form-control');

    // connect control and label
    control.id = control.id || controlIdGen.next().value;
    label.htmlFor = label.htmlFor || control.id;

    if (label.htmlFor === control.id) {
      label.id = label.id || (control.id + '-label');
      control.setAttribute('aria-labelledby', label.id);
    }

    // setup classes
    this.classList.add('form-group');
    this.classList.toggle('is-required', Boolean(control.required));

    control.classList.add('form-control');

    // observe control.disabled
    this.updateDisabled();
    this.observer.observe(this.control, {
      attributes: true,
      attributeFilter: ['disabled']
    });

    // observe control.validity
    if ('oninvalid' in control) {
      control.oninvalid = this.onInvalid.bind(this);
    } else if (control.checkValidity) { // IE
      control.onblur = event => {
        if (event.target.checkValidity()) {
          this.resetInvalid();
        } else {
          this.onInvalid(event);
        }
      };
    }
  }

  onInvalid (event) {
    event.preventDefault();

    if (!this.alert) {
      const id = (this.control.id + '-alert');
      this.alert = this.createAlert(id);
      this.control.setAttribute('aria-describedby', id);
      this.appendChild(this.alert);
    }

    this.alert.textContent = this.control.validationMessage;
    this.classList.add('is-invalid');
  }

  createAlert (id) {
    const alert = document.createElement('p');
    alert.setAttribute('role', 'alert');
    alert.classList.add('invalid-feedback');
    alert.id = id;
    return alert;
  }

  disconnectedCallback () {
    this.control.oninvalid = null;
    this.control.onblur = null;
    this.observer.disconnect();

    this.label = null;
    this.control = null;
    this.resetInvalid();
  }

  updateDisabled () {
    this.classList.toggle('is-disabled', this.control.hasAttribute('disabled'));
  }

  resetInvalid () {
    this.classList.remove('is-invalid');

    if (this.alert) {
      this.alert.remove();
      this.alert = null;
    }
  }

}

customElements.define('form-group', FormGroup);
